import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useSearch } from '../context/SearchContext';
import { FaSearch, FaList, FaBook, FaClock, FaCog } from 'react-icons/fa';

function AppNavbar() {
  const { activeView, setActiveView } = useSearch();

  return (
    <Navbar bg="primary" variant="dark" className="mb-3 sticky-top">
      <Container fluid className="px-2">
        <Nav>
          <Nav.Link 
            as="button" 
            active={activeView === 'search'}
            onClick={() => setActiveView('search')}
            className="px-2 px-sm-3 d-flex flex-column align-items-center"
            title="Search"
          >
            <FaSearch className="mb-1" />
            <span className="d-none d-sm-inline small">Search</span>
          </Nav.Link>
          <Nav.Link 
            as="button"
            active={activeView === 'results'}
            onClick={() => setActiveView('results')}
            className="px-2 px-sm-3 d-flex flex-column align-items-center"
            title="Results"
          >
            <FaList className="mb-1" />
            <span className="d-none d-sm-inline small">Results</span>
          </Nav.Link>
          <Nav.Link 
            as="button"
            active={activeView === 'book'}
            onClick={() => setActiveView('book')}
            className="px-2 px-sm-3 d-flex flex-column align-items-center"
            title="Book"
          >
            <FaBook className="mb-1" />
            <span className="d-none d-sm-inline small">Book</span>
          </Nav.Link>
          <Nav.Link 
            as="button"
            active={activeView === 'history'}
            onClick={() => setActiveView('history')}
            className="px-2 px-sm-3 d-flex flex-column align-items-center"
            title="History"
          >
            <FaClock className="mb-1" />
            <span className="d-none d-sm-inline small">History</span>
          </Nav.Link>
          <Nav.Link 
            as="button"
            active={activeView === 'settings'}
            onClick={() => setActiveView('settings')}
            className="px-2 px-sm-3 d-flex flex-column align-items-center"
            title="Settings"
          >
            <FaCog className="mb-1" />
            <span className="d-none d-sm-inline small">Settings</span>
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default AppNavbar; 